import { HiX } from 'react-icons/hi';

export const Errors = ({
  className,
  title,
  text,
}: {
  className?: string;
  title?: string;
  text?: string;
}) => {
  return (
    <div className={`flex flex-col gap-6 items-center px-0 py-6 ${className}`}>
      <div className="bg-red-100 flex items-center justify-center rounded-full w-12 h-12">
        <HiX className="w-6 h-6 text-red-500" />
      </div>

      <div className="flex flex-col gap-4 items-center w-full">
        <div className="font-inter font-medium text-base text-center text-gray-900 leading-[1.5] w-full">
          {title}
        </div>
        <div className="font-inter text-base text-center text-gray-500 leading-[1.5] w-full">
          {text}
        </div>
      </div>
    </div>
  );
};
